import React from "react";

//Material-UI Core Components
import Box from "@material-ui/core/Box";

//Custom Components
import AdminPage from "UI/AppPage/AdminPage";
import ProfileForm from "Views/ProfilePage/ProfileForm";

const AdminProfilePage = React.memo((props) => {
  return (
    <AdminPage>
      <Box m={2}>
        <ProfileForm />
      </Box>
    </AdminPage>
  );
})

export default AdminProfilePage;
